import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { PurchaseAddOnsService } from '../../services/purchase-add-ons.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { PurchaseService } from '../../services/purchase.service';

@Component({
  selector: 'plan-tier-picker',
  templateUrl: './plan-tier-picker.component.html',
  styleUrls: ['./plan-tier-picker.component.scss'],
  standalone: false,
})
export class PlanTierPickerComponent {
  canAccessUnlimitedPlan = this.companyStateService.isK12Customer();
  isUnlimitedPlan = this.canAccessUnlimitedPlan;
  isVolumePlan: boolean;
  periodMonthly = this.purchaseService.purchase?.volumePlan?.isMonthly;
  totalPrice = 0;
  selectedProductCode = '';

  displayCount = this.purchaseService.purchase?.volumePlan?.licenses;
  unlimitedCount = 1;

  @ViewChild('planPickerForm')
  public planPickerForm: NgForm;

  constructor(
    private companyStateService: CompanyStateService,
    private purchaseService: PurchaseService,
    private purchaseStepsService: PurchaseStepsService,
    private purchaseAddOnsService: PurchaseAddOnsService,
  ) {}

  updatePlan() {
    if (this.isUnlimitedPlan) {
      this.purchaseService.pickUnlimitedPlan(this.unlimitedCount);
    } else {
      this.purchaseService.clearUnlimitedPlan();
    }
    if (this.isVolumePlan) {
      this.purchaseService.pickVolumePlan(
        this.displayCount,
        this.periodMonthly,
        this.totalPrice,
        this.selectedProductCode,
      );
    } else {
      this.purchaseService.clearVolumePlan();
    }

    for (const addOn of this.purchaseAddOnsService.getSelectedAddOns()) {
      this.purchaseService.pickAddOnPlan(
        addOn.type,
        addOn.quantity,
        addOn.plan.productCode,
        addOn.totalPrice,
      );
    }

    this.purchaseStepsService.setNextStep();
  }

  updateProductCode(value) {
    this.selectedProductCode = value;
  }

  updateTotalPrice(value) {
    this.totalPrice = value;
  }
}
